import type { AxiosError } from 'axios';
import type {
  CognitoSignInSuccessResponse,
  VerifyOtpRequest,
} from '@bvengineering/cas-member-gateway-service-client';
import { useApiMutation } from '@/api/hooks/useMutation';

interface VerifyOtpVariables {
  magicToken?: string;
  request: VerifyOtpRequest;
}

export function useVerifyOtp() {
  return useApiMutation<CognitoSignInSuccessResponse, AxiosError, VerifyOtpVariables>({
    mutationFn:
      (api) =>
      async ({ magicToken, request }) => {
        const response = await api.otp.creatorsAuthOTPControllerVerifyOtp(request, magicToken);
        return response.data;
      },
  });
}
